export const NOTIFICATION_EXTRA_ORDER_STATUS_KEY = 'order_status' as const;
export const NOTIFICATION_EXTRA_ORDER_ID_KEY = 'order_id' as const;
export const NOTIFICATION_EXTRA_ACTION_KEY = 'action';
